import { render, staticRenderFns } from "./ColaboradorUsers.vue?vue&type=template&id=a2d824bc&scoped=true"
import script from "./ColaboradorUsers.vue?vue&type=script&lang=js"
export * from "./ColaboradorUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d824bc",
  null
  
)

export default component.exports